<template>
  <v-dialog
    v-model="value"
    persistent
    width=300>
    <v-card
      color="white"
      class="main--text"
      dark>
      <v-container
        style="padding-top:0px"
        fluid>
        <v-row
          class="no--vertical--paddings"
          justify=center>
          <v-col
            cols=auto>
            <span style="color:black">{{message}}</span>
          </v-col>
        </v-row>
        <v-progress-linear
          indeterminate
          color="primary"
          />
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    message: {
      type: String,
      default: '実行しています',
      required:false
    }
  }
}
</script>

<style scoped>
.no--vertical--paddings {
  padding: 0px 12px;
}
</style>

